import type { State } from '@src/redux/configureStore'
import type { TotalsPublicObjects } from '@src/redux/reducers/external.lists/default.state'

export const getTotals = (state: State) =>
  (state.externalLists.totalsPublicObjects || {}) as TotalsPublicObjects
export const getList = (state: State) =>
  state.externalLists.publicObjectsList || []
